import PropTypes from 'prop-types';

export const inventory = PropTypes.shape({
  age: PropTypes.number,
  number_per_ha: PropTypes.number.isRequired,
  dominant_height: PropTypes.number.isRequired,
  basimetric_area: PropTypes.number.isRequired,
});